import React, { useState } from 'react';
import ReactTooltip from 'react-tooltip';
import { Col, Tooltip, Button, Popover, OverlayTrigger } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import ReactHtmlParser, { processNodes, convertNodeToElement, htmlparser2 } from 'react-html-parser';




const File_mp3_load = (props) => {
    const [somma, calcola_somma] = useState('');



    function mostra_ultima_volta_jump() {
        var date = new Date();
        var timestamp = Math.round(date.getTime() / 1000 / 60 | 0);
        var tempo_passato = timestamp - props.item.microtime_last
        var stringa
        if (tempo_passato < 60) {
            stringa = 'last time ' + tempo_passato + ' minuti'
            return stringa;
        }
        if (tempo_passato < 60 * 24) {
            tempo_passato = tempo_passato / 60
            stringa = 'last time ' + tempo_passato.toFixed(1) + ' ore'
            return stringa;
        }
        tempo_passato = tempo_passato / (24 * 60)
        stringa = 'last time ' + tempo_passato.toFixed(1) + ' giorni'
        return stringa;

    }



    const popover = (
        <Popover id="popover-basic">
            <Popover.Title as="h3">Risposta</Popover.Title>
            <Popover.Content>
                <p>
                    {ReactHtmlParser(props.item.risposta)}
                </p>
            </Popover.Content>
        </Popover>
    );
    const popover1 = (
        <Popover id="popover-basic">
            <Popover.Title as="h3">Risposta</Popover.Title>
            <Popover.Content>
                <p>
                    {ReactHtmlParser(props.item.risposta)}
                </p>
            </Popover.Content>
        </Popover>
    );
    return (
        <div>


            <Col>

                <OverlayTrigger trigger="click" key={'top'} rootClose placement={'left'} overlay={<Tooltip id={`tooltip-top`}>
                    {props.item.indice_end + ' on '}
                    {props.item.indice_aux + ' = '}  <strong>
                        {props.item.indice_end - props.item.indice_aux}</strong> -
                <p>
                        {mostra_ultima_volta_jump()}
                    </p>
                </Tooltip>
                } >
                    <Button variant="success">Tooltip</Button>

                </OverlayTrigger>
            </Col>
            <Col>

                <OverlayTrigger trigger="click" rootClose placement="left" overlay={popover1}>
                    <Button variant="success">Risposta</Button>
                </OverlayTrigger>
            </Col>
            <Col>
                <OverlayTrigger trigger="hover" placement="left" overlay={popover}>

                    <input type="text" value={props.item.n_q} placeholder="Aggiungi memo" />
                </OverlayTrigger>
            </Col>
        </div>
    )
}

export default File_mp3_load;
